module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "90vh",
      "overflow": "auto",
      "background-color": "#FAFAFA"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.showPromotion) ? _c('div', {
    staticClass: "slogan"
  }, [_vm._v(_vm._s(_vm.promotion.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "service-wrapper"
  }, _vm._l((_vm.serviceItems), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('span', {
      staticClass: "service-icon"
    }, [_c('img', {
      attrs: {
        "src": item.serviceSvgUrl,
        "data-src": item.serviceSvgUrl
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "service-txt",
      domProps: {
        "textContent": _vm._s(item.serviceTxt)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "service-sub-txt",
      domProps: {
        "textContent": _vm._s(item.serviceSubTxt)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('van-row', _vm._l((_vm.categoryList), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": 24 / _vm.categoryList.length
      }
    }, [_c('van-button', {
      attrs: {
        "round": "",
        "size": "small",
        "block": "",
        "plain": _vm.plain[index],
        "color": "#5878FA"
      },
      on: {
        "click": function($event) {
          return _vm.onChange(index, item)
        }
      }
    }, [_vm._v(_vm._s(item.dictValue))])], 1)
  }), 1)], 1), _vm._v(" "), _c('div', [(_vm.plain[0]) ? _c('qualitative-tech', {
    ref: "qualitativeTech",
    attrs: {
      "dataList": _vm.productList
    },
    on: {
      "callback": _vm.handleProduct
    }
  }) : _vm._e(), _vm._v(" "), (_vm.plain[1]) ? _c('quantitative-tech', {
    ref: "send",
    attrs: {
      "dataList": _vm.productList
    },
    on: {
      "callback": _vm.handleProduct
    }
  }) : _vm._e(), _vm._v(" "), (_vm.plain[2]) ? _c('modification-tech', {
    attrs: {
      "dataList": _vm.productList
    },
    on: {
      "callback": _vm.handleProduct
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('proteomics-desc')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shopping-footer"
  }, [_c('van-button', {
    staticClass: "bottom-button-large",
    attrs: {
      "color": "#5878FA",
      "type": "danger",
      "text": "下一步"
    },
    on: {
      "click": _vm.onClickNextStep
    }
  })], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-name"
  }, [_c('span', {
    staticClass: "zh-name"
  }, [_vm._v("蛋白组学")]), _vm._v(" "), _c('span', {
    staticClass: "en-name"
  }, [_vm._v("Proteomics")]), _vm._v(" "), _c('span', {
    staticClass: "sub-name"
  }, [_vm._v("强大生信团队/软硬件先进/质控严格/交付周期短")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-377156f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Proteomics/Purchase.vue
// module id = 1599
// module chunks = 8